import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { ASSETS_CACHE_KEY } from 'services/queryKeys';
import { GreenerUnit } from 'types';
import { DeviceTypeId } from 'types';
import { DEVICE_TYPE_IDS } from 'utils/constants';
import { addQueryParam } from 'utils/query';
import { ReactQueryConfig } from './hooks.types';

export const useGetGreenerUnits = ({
  deviceType,
  queryConfig = {},
  queryParams,
}: {
  deviceType?: DeviceTypeId;
  queryConfig?: ReactQueryConfig<GreenerUnit[]>;
  queryParams?;
} = {}) => {
  let axiosQueryUrl = queryParams?.queryUrl || '/greener-units/';

  if (deviceType) {
    axiosQueryUrl = addQueryParam({
      url: axiosQueryUrl,
      key: 'device_type',
      value: deviceType,
    });
  }

  if (queryParams?.owningOrganisationId) {
    axiosQueryUrl = addQueryParam({
      url: axiosQueryUrl,
      key: 'owning_organisation_id__eq',
      value: queryParams.owningOrganisationId,
    });
  }

  if (queryParams?.hasSecondInverter !== undefined) {
    axiosQueryUrl = addQueryParam({
      url: axiosQueryUrl,
      key: 'has_second_inverter__is',
      value: queryParams.hasSecondInverter,
    });
  }

  const deviceTypeKey =
    Object.keys(DEVICE_TYPE_IDS).find((key) => DEVICE_TYPE_IDS[key as keyof typeof DEVICE_TYPE_IDS] === deviceType) ??
    'all';

  const deviceModelKey =
    queryParams?.hasSecondInverter !== undefined ? `hasSecondInverter=${queryParams.hasSecondInverter}` : undefined;

  const axiosQueryKey = queryParams?.queryKey || ASSETS_CACHE_KEY({ deviceTypeKey, deviceModelKey });

  const { data, ...rest } = useAxiosQuery<GreenerUnit[]>(axiosQueryKey, axiosQueryUrl, {
    method: 'GET',
    ...queryConfig,
  });

  return {
    data,
    ...rest,
  };
};
